module.exports = __webpack_public_path__ + "img/gzh.7d60ef4b.png";